import React, { useState, useEffect, useMemo } from "react"
import {
  sortData,
  formatFaxNumber,
  getFaxNumberToDisplayInbound,
  getFaxNumberToDisplayOutbound,
  validateFaxNumberOnlyDigit,
  prepareFinalFaxNumber,
  isEmpty,
} from "../../utils/common"

import { FAX_ACTION } from "../../utils/constants"
import { post, get, remove } from "../../utils/apiClient"
import Pagination from "../../components/common/pagination"
import PaginationBe from "../../components/common/paginationBe"
import PhonebookModal from "../../components/settingTabs/phonebookModal"
import moment from "moment-timezone"
import toast from "react-hot-toast"
import { FaxNumberToolTip } from "../../components/common/faxNumberToolTip"
import {
  SquarePlus,
  SquarePen,
  SquareX,
  PhoneForwarded,
  Trash2,
  Copy,
  Undo2,
  View,
  StepForward,
  Download,
  RefreshCcw,
  FileX,
  ArrowBigLeft,
  FileText,
  CheckSquare,
  ChevronUp,
  ChevronDown,
  ChevronsUpDown,
  AlertTriangle,
} from "lucide-react"

const BoundInOut = ({
  selectedPractice,
  selectedFax,
  setSelectedFax,
  tab,
  searchText,
  flgReloadFaxes,
  reloadPractices,
  authUser,
  dateRange,
  practices,
}) => {
  const [faxes, setFaxes] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(100)
  const [fetchedCount, setFetchedCount] = useState(0)
  const [faxToCopy, setFaxToCopy] = useState(null)
  const [faxToUndo, setFaxToUndo] = useState(null)
  const [sortConfig, setSortConfig] = useState({
    key: "createdTimestamp",
    direction: "desc",
  })
  // const [paginationOffset, setPaginationOffset] = useState(0)
  // const [pageNextPrev, setPageNextPrev] = useState({
  //   next: false,
  //   prev: false,
  // })
  const [listLoading, setListLoading] = useState(false)
  const [recentSelectedFaxes, setRecentSelectedFaxes] = useState([])
  const [actionLoading, setActionLoading] = useState(false)

  const [addCommentPopup, setAddCommentPopup] = useState(null)
  const [editCommentPopup, setEditCommentPopup] = useState(null)
  const [deleteCommentPopup, setDeleteCommentPopup] = useState(null)
  const [showPhonebookPopup, setShowPhonebookPopup] = useState(null)
  const [showDeletePopup, setShowDeletePopup] = useState(null)
  //const faxesPerPage = 20

  const [copiedFaxType, setCopiedFaxType] = useState("INBOUND_FAX")
  const [showFUPopup, setShowFUPopup] = useState(false)
  const [showFFPopup, setShowFFPopup] = useState(false)

  const [showCancelPopup, setShowCancelPopup] = useState(null)

  const [loadingDownload, setLoadingDownload] = useState(null)

  const [paginationOffset, setPaginationOffset] = useState(0)

  const [lastRecord, setLastRecord] = useState(0)
  const [hoveredRow, setHoveredRow] = useState(null)
  const [activeRow, setActiveRow] = useState(null)

  const [copiedFaxIdCell, setCopiedFaxIdCell] = useState(null)

  // Fields to display
  let fields = [
    // {
    //   key: "originating_fax_tsid",
    //   label: "Fax number",
    //   sort: true,
    //   fixed: true,
    // },
    {
      key: "originating_fax_tsid",
      label: "Fax Number",
      fixed: true,
      style: { minWidth: "160px" },
    },
    {
      key: "completed_timestamp",
      label: "Received",
      sort: true,
      style: { minWidth: "160px" },
    },
    { key: "pages", label: "Pages" },
    // {
    //   key: "copiedToSubfolder",
    //   label: "Copied To",
    //   style: { width: "200px" },
    // },
    {
      key: "comment1",
      label: "Comment1",
      hide: dateRange?.length > 0 ? true : false,
      style: { width: "300px", textAlign: "left" },
    },
    {
      key: "comment2",
      label: "Comment2",
      hide: dateRange?.length > 0 ? true : false,
      style: { width: "300px", textAlign: "left" },
    },
    // { key: "fax_status", label: "Status" },
    { key: "fax_id", label: "Fax ID", style: { width: "100px" } },
  ]

  if (tab === "inbound" && selectedPractice?.type === "subfolder") {
    let subFolderComments = [
      {
        key: "inboundComment1",
        label: "Comment1",
        hide: dateRange?.length > 0 ? true : false,
        style: { width: "300px", textAlign: "left" },
      },
      {
        key: "inboundComment2",
        label: "Comment2",
        hide: dateRange?.length > 0 ? true : false,
        style: { width: "300px", textAlign: "left" },
      },
    ]
    if (copiedFaxType === "OUTBOUND_FAX") {
      subFolderComments = [
        {
          key: "outboundComment1",
          label: "Comment1",
          hide: dateRange?.length > 0 ? true : false,
          style: { width: "300px", textAlign: "left" },
        },
        {
          key: "outboundComment2",
          label: "Comment2",
          hide: dateRange?.length > 0 ? true : false,
          style: { width: "300px", textAlign: "left" },
        },
      ]
    }

    fields = [
      {
        key: "faxNumber",
        label: "Fax Number",
        fixed: true,
        style: { minWidth: "160px" },
      },
      {
        key: "completedTimestamp",
        label: "Completed",
        sort: true,
        style: { minWidth: "160px" },
      },
      { key: "pages", label: "Pages" },
      ...subFolderComments,
      { key: "faxId", label: "Fax Id", style: { width: "100px" } },
    ]
  }

  if (tab === "outbound") {
    fields = [
      {
        key: "destination_fax_csid",
        label: "Destination",
        sort: true,
        fixed: true,
        style: { minWidth: "160px" },
      }, // Fixed column
      {
        key: "completed_timestamp",
        label: "Completed",
        sort: true,
        style: { minWidth: "160px" },
      },
      // { key: "fax_id", label: "Fax ID" },
      { key: "pages", label: "Pages" },
      // {
      //   key: "copiedToSubfolder",
      //   label: "Copied To",
      // },
      { key: "transmission_data.transmission_status", label: "Status" },
      { key: "client_tracking_data.client_matter", label: "Comment1" },
      { key: "client_tracking_data.client_name", label: "Comment2" },
      { key: "appSender", label: "Sender" },
      { key: "fax_id", label: "Fax ID", style: { width: "100px" } },
    ]
  }

  // Search Filter
  let filteredFaxes = faxes?.filter((fax) => {
    if (fax?.fax_copied && selectedPractice?.type !== "subfolder") return false
    if (!searchText) return true

    const searchL = searchText.toLowerCase()

    if (tab === "inbound" && selectedPractice?.type === "practice") {
      // Fax Number
      const faxNumber = (getFaxNumberToDisplayInbound(fax) || "").replace(
        /-/g,
        "",
      )

      // Received
      const received = fax?.completed_timestamp
        ? moment
            .utc(fax.completed_timestamp)
            .tz("America/New_York")
            .format("MM/DD/YYYY hh:mm A")
        : ""

      // Fax ID
      const faxId = fax?.fax_id || fax?.faxId || ""

      // Comments
      const comment1 = fax?.comment1 || ""
      const comment2 = fax?.comment2 || ""

      return (
        [received, comment1, comment2].some((v) =>
          v.toLowerCase().includes(searchL),
        ) ||
        faxNumber.includes(searchL.replace(/-/g, "")) ||
        faxId.toString().toLowerCase().includes(searchL)
      )
    }

    if (tab === "outbound") {
      // Sender: extracted from client_reference_id
      const clientRef = fax?.client_tracking_data?.client_reference_id || ""
      const sender = clientRef.includes("_$$_")
        ? clientRef.split("_$$_")[1]
        : clientRef

      // Destination
      const destination = (getFaxNumberToDisplayOutbound(fax) || "").replace(
        /-/g,
        "",
      )

      // Completed
      const completed = fax?.completed_timestamp
        ? moment
            .utc(fax.completed_timestamp)
            .tz("America/New_York")
            .format("MM/DD/YYYY hh:mm A")
        : ""

      // Status
      const rawStatus = fax?.transmission_data?.transmission_status || ""
      const statusErrorCode = fax?.transmission_data?.error_code || ""
      const statusErrorMsg = fax?.transmission_data?.error_message || ""
      const status =
        rawStatus === "ERROR"
          ? `${statusErrorCode} | ${rawStatus} - ${statusErrorMsg}`
          : rawStatus

      // Fax ID
      const faxId = fax?.fax_id || fax?.faxId || ""

      return (
        [sender, completed, status, faxId.toString()].some((v) =>
          v.toLowerCase().includes(searchL),
        ) || destination.includes(searchL.replace(/-/g, ""))
      )
    }

    // Subfolder (copied tab)
    const faxNumber = (fax?.faxNumber || "").replace(/-/g, "")
    const completed = fax?.completedTimestamp
      ? moment(fax.completedTimestamp).isValid()
        ? moment
            .utc(fax.completedTimestamp)
            .tz("America/New_York")
            .format("MM/DD/YYYY hh:mm A")
        : fax.completedTimestamp
      : ""
    const faxId = fax?.faxId || fax?.fax_id || ""
    const comment1 = fax?.inboundComment1 || fax?.outboundComment1 || ""
    const comment2 = fax?.inboundComment2 || fax?.outboundComment2 || ""

    return (
      [completed, fax?.completedTimestamp || "", comment1, comment2].some((v) =>
        v.toString().toLowerCase().includes(searchL),
      ) ||
      faxNumber.includes(searchL.replace(/-/g, "")) ||
      faxId.toString().toLowerCase().includes(searchL)
    )
  })

  if (
    // INBOUND_FAX faxes for subfolder
    selectedPractice?.type === "subfolder" &&
    copiedFaxType === "INBOUND_FAX"
  ) {
    filteredFaxes = filteredFaxes.filter((fax) => fax.faxType === "INBOUND_FAX")
  } else if (
    // OUTBOUND_FAX faxes for subfolder
    selectedPractice?.type === "subfolder" &&
    copiedFaxType === "OUTBOUND_FAX"
  ) {
    filteredFaxes = filteredFaxes.filter(
      (fax) => fax.faxType === "OUTBOUND_FAX",
    )
  }

  // Sort and Paginate Data
  // const sortedFaxes = sortData(filteredFaxes, sortConfig)
  // const currentFaxes = sortedFaxes

  const sortedFaxes = sortData(filteredFaxes, sortConfig)
  const startIdx = (currentPage - 1) * rowsPerPage
  const currentFaxes = sortedFaxes.slice(startIdx, startIdx + rowsPerPage)
  const totalPages = Math.ceil(filteredFaxes.length / rowsPerPage)

  //const currentFaxes = paginateData(sortedFaxes, currentPage, faxesPerPage)
  //const totalPages = Math.ceil(filteredFaxes.length / faxesPerPage)

  const fetchFaxes = async (notifyError = false) => {
    if (
      selectedPractice?.faxNumberAttributes?.length === 0 &&
      selectedPractice.type === "practice"
    ) {
      return
    }

    if (["inbound", "outbound"].includes(tab)) {
      try {
        let ibUrl = `/fax/inboundFaxes`
        if (selectedPractice.type === "subfolder") {
          ibUrl = `/practice/${selectedPractice?.practiceId}/subfolder/${selectedPractice?.subFolderName}/copied-faxes`
        }

        let obUrl = `/fax/outboundFaxes`
        if (selectedPractice.type === "subfolder") {
          obUrl = `/practice/${selectedPractice?.practiceId}/subfolder/${selectedPractice?.subFolderName}/copied-faxes`
        }

        let url = tab === "inbound" ? ibUrl : obUrl

        // Merging Data

        if (selectedPractice.type === "practice") {
          // const updatedFaxAttributes = Array.isArray(
          //   selectedPractice?.faxNumberAttributes,
          // )
          //   ? selectedPractice.faxNumberAttributes.map((attr) => ({
          //       ...attr,
          //       ...(dateRange?.length > 1 && {
          //         minTS: dateRange[0],
          //         maxTS: dateRange[1],
          //       }),
          //     }))
          //   : []

          const dateParams =
            dateRange?.length > 0 && selectedPractice
              ? { minTS: dateRange[0], maxTS: dateRange[1] }
              : {}

          const data = await post(
            url,
            {
              userId: selectedPractice?.userId,
              faxNumber: selectedPractice?.faxNumber,
              ...dateParams,
              pageNumber: paginationOffset,
            },
            {
              appId: selectedPractice?.appId,
            },
          )

          const mergedData = data.faxes.map((fax) => {
            return {
              userId: selectedPractice?.userId,
              faxNumber: selectedPractice?.faxNumber,
              faxId: fax.fax_id,
              faxStatus: fax.fax_status,
              ...fax,
            }
          })

          setLastRecord(Number(data.last_record))
          setFaxes(mergedData)
          setFetchedCount(data.faxes.length)
        } else if (selectedPractice.type === "subfolder") {
          const data = await get(url)

          const mergedData = data.map((fax) => {
            return {
              ...fax,
              fax_id: fax.faxId,
              fax_status: fax.faxStatus,
            }
          })

          setFaxes(tab === "inbound" || tab === "outbound" ? mergedData : [])
        }

        setListLoading(false)
      } catch (err) {
        setListLoading(false)
        if (notifyError) {
          toast.error(err, {
            duration: 5000,
          })
        }
      }
    }
  }

  const handleCopySubmit = async (appConfig) => {
    setActionLoading(true)
    try {
      await post("/admin/copy-faxes", appConfig)
      setFaxToCopy(null)
      await fetchFaxes()
      //await resetFaxes("delete", appConfig?.faxId)
      await reloadPractices()
      toast.success("Moved successfully")
      setSelectedFax(null)
    } catch (error) {
      toast.error("Failed to move")
    } finally {
      setFaxToCopy(null)
      setActionLoading(false)
      setShowDeletePopup(null)
    }
  }

  const handleUndoSubmit = async (fax) => {
    setActionLoading(true)
    try {
      await remove(`/admin/copy-faxes/${fax?.copiedId}`)
      setFaxToUndo(null)
      //await fetchFaxes()
      await resetFaxes("delete", fax?.faxId)
      await reloadPractices()
      toast.success("Undo successfully")
      setSelectedFax(null)
    } catch (error) {
      toast.error("Failed to Undo")
    } finally {
      setFaxToUndo(null)
      setActionLoading(false)
    }
  }

  const handleFaxPermanentDelete = async (copiedId, appId, faxId) => {
    setActionLoading(true)
    try {
      await remove(
        `/admin/copy-faxes/${copiedId}?permanentDelete=true`,
        {},
        {
          appId,
        },
      )
      setShowDeletePopup(null)
      await fetchFaxes()
      //await resetFaxes("delete", faxId)
      await reloadPractices()
      toast.success("Fax deleted successfully")
    } catch (error) {
      toast.error("Failed to Delete")
    } finally {
      setShowDeletePopup(null)
      setActionLoading(false)
    }
  }

  const resetFaxes = async (action, faxId, key = null, value = "") => {
    setFaxes((prev) => {
      if (action === "delete") {
        return prev.filter((fax) => (fax?.fax_id || fax?.faxId) !== faxId)
      } else if (action === "update") {
        return prev.map((fax) =>
          (fax?.fax_id || fax?.faxId) === faxId
            ? { ...fax, [key]: value }
            : fax,
        )
      }
      return prev
    })
  }

  const handleCommentAddEdit = async (data) => {
    setActionLoading(true)
    try {
      await post(`/fax/inbound/comment`, {
        faxId: data?.faxId,
        comment: data?.comment,
        userId: data?.userId,
        field: data?.commentKey
          ?.replace(/^inbound/, "")
          .replace(/^outbound/, "")
          .toLowerCase(),
      })

      toast.success(
        `Comment has been ${
          data?.action === "edit" ? "updated" : "added"
        } successfully`,
        {
          duration: 5000,
        },
      )
      setActionLoading(false)
      setAddCommentPopup(null)
      setEditCommentPopup(null)
      //fetchFaxes()
      await resetFaxes("update", data?.faxId, data?.commentKey, data?.comment)
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
      setAddCommentPopup(null)
      setEditCommentPopup(null)
    }
  }

  const handleDeleteComment = async (deleteCommentPopup) => {
    setActionLoading(true)

    const faxId = deleteCommentPopup?.fax_id || deleteCommentPopup?.faxId

    try {
      await remove(
        `/fax/inbound/${deleteCommentPopup?.fax_id}/comment/${deleteCommentPopup?.commentKey
          ?.replace(/^inbound/, "")
          .replace(/^outbound/, "")
          .toLowerCase()}`,
      )

      toast.success("Comment has been removed successfully", {
        duration: 5000,
      })
      setActionLoading(false)
      setDeleteCommentPopup(null)
      //fetchFaxes()
      await resetFaxes("update", faxId, deleteCommentPopup?.commentKey, "")
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
      setDeleteCommentPopup(null)
    }
  }

  const handleAddOrEditPhonebook = async (data) => {
    setActionLoading(true)
    try {
      await post("/phonebook/save", {
        firstName: data.firstName,
        lastName: data.lastName,
        emailAddress: data.emailAddress,
        company: data.company,
        faxNumber: data.faxNumber,
        practiceName: data.practiceName,
        type: data.type,
        oldFaxNumber: data.oldFaxNumber,
        oldPractice: data.oldPractice,
      })

      setShowPhonebookPopup(false)
      setActionLoading(false)

      toast.success(`Phonebook has been added successfully`, {
        duration: 5000,
      })
    } catch (error) {
      setActionLoading(false)
      toast.error(error, {
        duration: 5000,
      })
    }
  }

  // Handlers
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }))
  }

  const handleFaxClick = (fax) => {
    setRecentSelectedFaxes([fax.fax_id, ...recentSelectedFaxes])
    if (fax?.fax_id !== selectedFax?.fax_id) {
      setSelectedFax({
        appId: selectedPractice?.appId,
        ...fax,
      })
    } else {
      setSelectedFax(null)
    }
  }
  const handleDeleteFax = () => {
    if (showDeletePopup?.permanentDelete) {
      handleFaxPermanentDelete(
        showDeletePopup.copiedId,
        showDeletePopup.appId,
        showDeletePopup.faxId,
      )
    } else {
      let outboundComments = {}
      if (tab === "outbound" || copiedFaxType === "OUTBOUND_FAX") {
        outboundComments = {
          outboundComment1:
            showDeletePopup?.client_tracking_data?.client_matter ||
            showDeletePopup?.outboundComment1,
          outboundComment2:
            showDeletePopup?.client_tracking_data?.client_name ||
            showDeletePopup?.outboundComment2,
        }
      }

      handleCopySubmit({
        practiceId: selectedPractice.practiceId,
        subFolder: "Trash",
        userId: showDeletePopup.userId,
        faxId: showDeletePopup.fax_id,
        completedTimestamp: moment
          .utc(showDeletePopup.completed_timestamp)
          .tz("America/New_York")
          .format("MM/DD/YYYY hh:mm A"),
        pages: showDeletePopup.pages,
        faxStatus: showDeletePopup.fax_status,
        appId: selectedPractice.appId || showDeletePopup.appId,
        faxType:
          tab === "outbound" || copiedFaxType === "OUTBOUND_FAX"
            ? "OUTBOUND_FAX"
            : "INBOUND_FAX",
        faxNumber:
          selectedPractice?.type === "subfolder"
            ? showDeletePopup.faxNumber // For sub folder
            : tab === "outbound"
              ? getFaxNumberToDisplayOutbound(showDeletePopup)
              : getFaxNumberToDisplayInbound(showDeletePopup),
        ...outboundComments,
      })
    }
  }

  const handleSendToUser = async (data) => {
    setActionLoading(true)

    try {
      await post("/fax/forwardFax", data, {
        appId: data?.appId,
        faxNumber: data?.faxNumber,
        faxAction: FAX_ACTION.forwardToUser,
        originatingFaxNumber: data?.faxNumberToDisplay,
      })
      setShowFUPopup(null)
      setActionLoading(false)
      toast.success("Fax has been forwarded successfully", {
        duration: 5000,
      })
    } catch (error) {
      console.error("Failed to forward fax", error)
      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  const handleSendFax = async (data) => {
    setActionLoading(true)
    try {
      await post("/fax/sendfax", data, {
        appId: data?.appId,
        faxAction: FAX_ACTION.forwardToFax,
        originatingFaxNumber: data?.faxNumberToDisplay,
        faxNumber: data?.faxNumber,
      })

      setShowFFPopup(null)
      setActionLoading(false)
      toast.success("Fax has been sent successfully", {
        duration: 5000,
      })
    } catch (error) {
      console.error("Failed to send fax", error)

      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  const handleDownload = async (fax) => {
    setLoadingDownload(fax.fax_id)
    try {
      const faxNumberToDisplay =
        tab === "outbound"
          ? getFaxNumberToDisplayOutbound(fax)
          : getFaxNumberToDisplayInbound(fax)

      let headers = { appId: fax?.appId }
      if (selectedPractice?.type !== "subfolder") {
        headers = {
          faxNumber: fax?.faxNumber,
          faxAction: FAX_ACTION[tab],
          // appId: fax?.appId || DEFAULT_APP_ID,
          appId: selectedPractice?.appId,
          originatingFaxNumber: faxNumberToDisplay,
        }
      }

      const data = await post(
        `/fax/image`,
        { userId: fax?.userId, faxId: fax?.fax_id },
        headers,
      )

      if (!data?.image) {
        toast.error("No document available to download")
        return
      }

      const byteCharacters = atob(data.image)
      const byteArray = new Uint8Array(
        Array.from(byteCharacters, (c) => c.charCodeAt(0)),
      )
      const blob = new Blob([byteArray], { type: "application/pdf" })
      const url = URL.createObjectURL(blob)

      const link = document.createElement("a")
      link.href = url
      link.download = `${fax?.fax_id || fax?.faxId || "document"}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      setLoadingDownload(false)
    } catch (err) {
      toast.error("Failed to download fax")
      setLoadingDownload(false)
    }
  }

  const handleCancelFax = async (fax) => {
    setActionLoading(true)
    try {
      await post(
        "/fax/cancel",
        {
          userId: fax?.userId,
          faxId: fax?.faxId,
        },
        {
          appId: selectedPractice?.appId,
          faxAction: FAX_ACTION.cancel,
          originatingFaxNumber:
            tab === "outbound"
              ? getFaxNumberToDisplayOutbound(fax)
              : getFaxNumberToDisplayInbound(fax),
          faxNumber: fax?.faxNumber,
        },
      )

      toast.success("Fax has been cancelled successfully", {
        duration: 5000,
      })
      setActionLoading(false)
      setShowCancelPopup(null)
      fetchFaxes()
    } catch (error) {
      console.error("Failed to cancel user", error)
      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  const reloadFaxes = async (notifyError = false) => {
    setSelectedFax(null)
    setListLoading(true)
    await fetchFaxes(notifyError)
    setListLoading(false)
  }

  const getFaxRowId = (fax) => fax?.fax_id || fax?.faxId

  const getNestedValue = (obj, path) =>
    path.split(".").reduce((acc, key) => acc?.[key], obj)

  useEffect(() => {
    setCurrentPage(1)
    if (paginationOffset === 0) {
      if (selectedPractice) reloadFaxes(true)
    } else {
      setPaginationOffset(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice, tab, dateRange])

  useEffect(() => {
    if (selectedPractice) reloadFaxes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationOffset])

  return (
    <>
      {listLoading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: 0,
          }}
        >
          {/* Faxes List */}

          {!selectedPractice ? (
            <div>
              <div style={{ display: "flex", margin: "20px" }}>
                <ArrowBigLeft size={18} color="grey" />
                <span style={{ marginLeft: "5px" }}>
                  Please select Practice or Subfolder from left panel
                </span>
              </div>
            </div>
          ) : (
            <div
              className="faxes-content"
              style={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {selectedPractice?.type === "subfolder" && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    <label className="radio-option-label">
                      <input
                        type="radio"
                        value="test"
                        checked={copiedFaxType === "INBOUND_FAX"}
                        onChange={() => setCopiedFaxType("INBOUND_FAX")}
                      />
                      INBOUND
                    </label>
                    <label className="radio-option-label">
                      <input
                        type="radio"
                        value="prod"
                        checked={copiedFaxType === "OUTBOUND_FAX"}
                        onChange={() => setCopiedFaxType("OUTBOUND_FAX")}
                      />
                      OUTBOUND
                    </label>
                  </div>
                </div>
              )}
              <div
                className="table-container"
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowX: "auto",
                  overflowY: "auto",
                }}
              >
                <table className="faxes-table sticky-cols-table">
                  <thead>
                    <tr>
                      {fields.map((field) => (
                        <th
                          key={field.key}
                          className="faxes-th"
                          style={{
                            cursor: field.sort ? "pointer" : "default",
                            ...field.style,
                          }}
                          onClick={() => {
                            if (field.sort) handleSort(field.key)
                          }}
                        >
                          {field?.ffLabel && tab === "inbound"
                            ? field?.ffLabel
                            : field.label}

                          <span>
                            {field.sort ? (
                              sortConfig.key === field.key ? (
                                sortConfig.direction === "asc" ? (
                                  <ChevronUp
                                    size={14}
                                    style={{ verticalAlign: "middle" }}
                                  />
                                ) : (
                                  <ChevronDown
                                    size={14}
                                    style={{ verticalAlign: "middle" }}
                                  />
                                )
                              ) : (
                                <ChevronsUpDown
                                  size={14}
                                  style={{ verticalAlign: "middle" }}
                                />
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </th>
                      ))}
                      {/* {(authUser.userRole === "ADMIN" ||
                        authUser.userRole === "USER") && ( */}

                      <th className="faxes-th" style={{ width: "200px" }}>
                        Action
                      </th>
                      {/* )} */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentFaxes.length > 0 ? (
                      currentFaxes.map((fax, i) => (
                        <tr
                          key={`${fax?.fax_id}_${i}`}
                          className={`fax-item ${
                            selectedFax?.fax_id === fax?.fax_id
                              ? "selected"
                              : hoveredRow === fax?.fax_id ||
                                  activeRow === fax?.fax_id
                                ? "row-highlighted"
                                : ""
                          } ${
                            fax?.image_downloaded === false &&
                            !recentSelectedFaxes.includes(fax?.fax_id)
                              ? "font-bold"
                              : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => {
                            setHoveredRow(fax?.fax_id)
                            if (activeRow !== fax?.fax_id) setActiveRow(null)
                          }}
                          onMouseLeave={() => setHoveredRow(null)}
                          onClick={() => {
                            handleFaxClick(fax)
                            setActiveRow(fax?.fax_id)
                          }}
                        >
                          {fields.map((field) => {
                            let f = getNestedValue(fax, field.key)

                            // Inbound faxnumber display
                            const faxNumberToDisplayTsid =
                              getFaxNumberToDisplayInbound(fax)

                            // Outbound faxnumber display
                            const faxNumberToDisplayCsid =
                              getFaxNumberToDisplayOutbound(fax)

                            if (field.fixed) {
                              let fixedColumnValue = getNestedValue(
                                fax,
                                field.key,
                              )

                              if (field?.key === "destination_fax_csid") {
                                fixedColumnValue = faxNumberToDisplayCsid
                              }

                              const showPhone =
                                !/[^0-9 _-]/.test(fixedColumnValue?.trim()) &&
                                fixedColumnValue?.length > 0

                              f = (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {selectedFax?.fax_id === fax?.fax_id ? (
                                      <span className="user-icon">
                                        <CheckSquare
                                          size={16}
                                          color="#16a34a"
                                        />
                                      </span>
                                    ) : (
                                      <span className="user-icon">
                                        <FileText size={16} color="#1d6fb8" />
                                      </span>
                                    )}
                                    {/* {getNestedValue(fax, field.key)} */}
                                    {formatFaxNumber(fixedColumnValue)}
                                  </div>

                                  {showPhone && (
                                    <span
                                      title="Add to phonebook"
                                      style={{
                                        marginLeft: "5px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <PhoneForwarded
                                        size={14}
                                        color="#218304ff"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setShowPhonebookPopup(
                                            formatFaxNumber(fixedColumnValue),
                                          )
                                        }}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  )}
                                </div>
                              )
                            } else if (
                              field?.key === "createdTimestamp" ||
                              field?.key === "completed_timestamp"
                            ) {
                              f = moment
                                .utc(fax[field.key])
                                .tz("America/New_York")
                                .format("MM/DD/YYYY hh:mm A")
                            } else if (
                              field?.key ===
                              "transmission_data.transmission_status"
                            ) {
                              const status = getNestedValue(fax, field.key)
                              const statusErrorMsg = getNestedValue(
                                fax,
                                "transmission_data.error_message",
                              )

                              const statusErrorCode = getNestedValue(
                                fax,
                                "transmission_data.error_code",
                              )

                              f =
                                status === "ERROR"
                                  ? `${statusErrorCode} | ${status} - ${statusErrorMsg}`
                                  : status
                            }

                            if (field?.key === "originating_fax_tsid") {
                              const showPhone =
                                !/[^0-9 _-]/.test(
                                  faxNumberToDisplayTsid?.trim(),
                                ) && faxNumberToDisplayTsid?.length > 0

                              f = (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {selectedFax?.fax_id === fax?.fax_id ? (
                                      <span className="user-icon">
                                        <CheckSquare
                                          size={16}
                                          color="#16a34a"
                                        />
                                      </span>
                                    ) : (
                                      <span className="user-icon">
                                        <FileText size={16} color="#1d6fb8" />
                                      </span>
                                    )}
                                    <span>
                                      {formatFaxNumber(faxNumberToDisplayTsid)}
                                    </span>
                                  </div>

                                  {showPhone && (
                                    <span
                                      title="Add to phonebook"
                                      style={{
                                        marginLeft: "5px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <PhoneForwarded
                                        size={14}
                                        color="#218304ff"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setShowPhonebookPopup(
                                            formatFaxNumber(
                                              faxNumberToDisplayTsid,
                                            ),
                                          )
                                        }}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  )}
                                </div>
                              )
                            }

                            if (
                              [
                                "comment1",
                                "comment2",
                                "inboundComment1",
                                "inboundComment2",
                                "outboundComment1",
                                "outboundComment2",
                              ].includes(field?.key)
                            ) {
                              // pick the right comment value dynamically
                              const commentValue = fax?.[field.key]
                              const showCrudActions =
                                copiedFaxType === "INBOUND_FAX" ? true : false

                              let paramKey = null
                              if (field?.key === "comment1") {
                                paramKey = "comment1"
                              } else if (field?.key === "comment2") {
                                paramKey = "comment2"
                              } else if (field?.key === "inboundComment1") {
                                paramKey = "inboundComment1"
                              } else if (field?.key === "inboundComment2") {
                                paramKey = "inboundComment2"
                              }

                              f = (
                                <div
                                  className={`comment-cell ${
                                    commentValue ? "has-comment" : "no-comment"
                                  }`}
                                >
                                  {commentValue ? (
                                    <>
                                      <span className="comment-text">
                                        {commentValue}
                                      </span>
                                      {showCrudActions && (
                                        <span className="comment-actions">
                                          <span title="Edit">
                                            <SquarePen
                                              size={16}
                                              color="green"
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                setActiveRow(fax?.fax_id)
                                                setEditCommentPopup({
                                                  ...fax,
                                                  commentKey: paramKey,
                                                  commentEditKey: field?.key,
                                                })
                                              }}
                                            />
                                          </span>
                                          <span title="Remove">
                                            <SquareX
                                              size={16}
                                              color="red"
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                setActiveRow(fax?.fax_id)
                                                setDeleteCommentPopup({
                                                  ...fax,
                                                  commentKey: paramKey,
                                                  commentEditKey: field?.key,
                                                })
                                              }}
                                            />
                                          </span>
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {showCrudActions && (
                                        <span title="Add Comment">
                                          <SquarePlus
                                            size={16}
                                            color="#bca50f"
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              setActiveRow(fax?.fax_id)
                                              setAddCommentPopup({
                                                ...fax,
                                                commentKey: paramKey,
                                                commentEditKey: field?.key,
                                              })
                                            }}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </span>
                                      )}
                                    </>
                                  )}
                                </div>
                              )
                            }

                            if (field?.key === "appSender") {
                              const clientRef =
                                fax?.client_tracking_data?.client_reference_id

                              if (clientRef && clientRef.includes("_$$_")) {
                                const [, email] = clientRef.split("_$$_")
                                f = email
                              } else {
                                f = ""
                              }
                            }

                            let titleText = ""
                            const isFaxIdColumn =
                              field?.key === "fax_id" || field?.key === "faxId"
                                ? true
                                : false

                            if (isFaxIdColumn) {
                              titleText = fax?.fax_id || fax?.faxId
                            }

                            const faxIdValue = isFaxIdColumn
                              ? fax?.fax_id || fax?.faxId
                              : null
                            const cellKey = `${getFaxRowId(fax)}_${field.key}`

                            return (
                              <td
                                key={field.key}
                                //className="faxes-td"

                                className={`faxes-td ${
                                  isFaxIdColumn ? "faxes-td-limit" : "faxes-td"
                                }`}
                                title={titleText}
                                style={{
                                  ...field.style,
                                  ...(isFaxIdColumn
                                    ? { position: "relative" }
                                    : {}),
                                }}
                              >
                                {f}
                                {isFaxIdColumn && (
                                  <span
                                    className="fax-id-copy-btn"
                                    title="Copy Fax ID"
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      navigator.clipboard.writeText(faxIdValue)
                                      setCopiedFaxIdCell(cellKey)
                                      setTimeout(
                                        () => setCopiedFaxIdCell(null),
                                        1500,
                                      )
                                    }}
                                  >
                                    {copiedFaxIdCell === cellKey ? (
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          color: "green",
                                        }}
                                      >
                                        ✓
                                      </span>
                                    ) : (
                                      <Copy size={12} color="#888" />
                                    )}
                                  </span>
                                )}
                              </td>
                            )
                          })}

                          <td className="faxes-td">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {/* View */}
                              <span
                                onClick={(e) => {
                                  e.stopPropagation()
                                  handleFaxClick(fax)
                                  setActiveRow(fax?.fax_id)
                                }}
                                style={{ cursor: "pointer" }}
                                title="View"
                              >
                                <View size={18} color="#2E59D7" />
                              </span>

                              {/* Forward to User / Forward to Fax — outbound only, not E53 */}
                              {fax?.transmission_data?.error_code !== "E53" &&
                                selectedPractice?.type !== "subfolder" && (
                                  <>
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        setShowFUPopup({
                                          appId: selectedPractice?.appId,
                                          faxNumberToDisplay:
                                            tab === "outbound"
                                              ? getFaxNumberToDisplayOutbound(
                                                  fax,
                                                )
                                              : getFaxNumberToDisplayInbound(
                                                  fax,
                                                ),
                                          ...fax,
                                        })
                                        setActiveRow(fax?.fax_id)
                                      }}
                                      style={{ cursor: "pointer" }}
                                      title="Forward via Email"
                                    >
                                      <StepForward size={18} color="green" />
                                    </span>
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        setShowFFPopup({
                                          appId: selectedPractice?.appId,
                                          faxNumberToDisplay:
                                            tab === "outbound"
                                              ? getFaxNumberToDisplayOutbound(
                                                  fax,
                                                )
                                              : getFaxNumberToDisplayInbound(
                                                  fax,
                                                ),
                                          ...fax,
                                        })
                                        setActiveRow(fax?.fax_id)
                                      }}
                                      style={{ cursor: "pointer" }}
                                      title="Forward to Fax"
                                    >
                                      <StepForward size={18} color="purple" />
                                    </span>
                                  </>
                                )}

                              {/* Download */}
                              <span
                                onClick={(e) => {
                                  e.stopPropagation()
                                  handleDownload(fax)
                                  setActiveRow(fax?.fax_id)
                                }}
                                style={{ cursor: "pointer" }}
                                title="Download"
                              >
                                {loadingDownload === fax.fax_id ? (
                                  <RefreshCcw
                                    size={18}
                                    color="grey"
                                    style={{
                                      animation: "spin 1s linear infinite",
                                      transformOrigin: "center",
                                    }}
                                  />
                                ) : (
                                  <Download size={18} color="#1e7dc1ff" />
                                )}
                              </span>

                              {tab === "outbound" &&
                                ["NEW", "INPROGRESS"].includes(
                                  fax?.transmission_data?.transmission_status,
                                ) && (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setShowCancelPopup(fax)
                                      setActiveRow(fax?.fax_id)
                                    }}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    title="Cancel Fax"
                                  >
                                    <FileX size={18} color="brown" />
                                  </span>
                                )}

                              {/* Move / Undo / Trash — ADMIN or USER only */}
                              {(authUser.userRole === "ADMIN" ||
                                authUser.userRole === "USER") && (
                                <>
                                  {selectedPractice.type === "practice" ? (
                                    <>
                                      {/* Copy / Moved */}
                                      {!fax?.fax_copied ? (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setFaxToCopy(fax)
                                            setActiveRow(fax?.fax_id)
                                          }}
                                          style={{ cursor: "pointer" }}
                                          title="Move"
                                        >
                                          <Copy size={18} color="purple" />
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            cursor: "default",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                          }}
                                        >
                                          <CheckSquare
                                            size={16}
                                            color="#16a34a"
                                          />{" "}
                                          Moved
                                        </span>
                                      )}

                                      {/* Trash */}
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setShowDeletePopup(fax)
                                          setActiveRow(fax?.fax_id)
                                        }}
                                        style={{ cursor: "pointer" }}
                                        title="Move to Trash"
                                      >
                                        <Trash2 size={18} color="red" />
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      {/* Undo — subfolder with faxNumberAttributes */}
                                      {selectedPractice.faxNumberAttributes
                                        .length !== 0 && (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setFaxToUndo({
                                              copiedId: fax?.copiedId,
                                              faxId: fax?.faxId,
                                            })
                                            setActiveRow(fax?.fax_id)
                                          }}
                                          style={{ cursor: "pointer" }}
                                          title="Undo"
                                        >
                                          <Undo2 size={18} color="green" />
                                        </span>
                                      )}

                                      {/* Trash — subfolder, not Trash folder */}
                                      {selectedPractice?.subFolderName !==
                                        "Trash" && (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setShowDeletePopup(fax)
                                            setActiveRow(fax?.fax_id)
                                          }}
                                          style={{ cursor: "pointer" }}
                                          title="Move to Trash"
                                        >
                                          <Trash2 size={18} color="red" />
                                        </span>
                                      )}

                                      {/* Permanent Delete — Trash folder only */}
                                      {selectedPractice?.subFolderName ===
                                        "Trash" && (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setShowDeletePopup({
                                              ...fax,
                                              permanentDelete: true,
                                            })
                                            setActiveRow(fax?.fax_id)
                                          }}
                                          style={{ cursor: "pointer" }}
                                          title="Permanent Delete"
                                        >
                                          <Trash2 size={18} color="red" />
                                        </span>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="100%"
                          style={{
                            textAlign: "center",
                            padding: "10px",
                            border: "1px solid #ccc",
                          }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {/* Pagination Controls */}

          {selectedPractice?.type === "subfolder" ? (
            <>
              {currentFaxes.length > 0 && (
                <div
                  className="faxes-pagination"
                  style={{ justifyContent: "end" }}
                >
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    rowsPerPage={rowsPerPage}
                    totalRows={filteredFaxes.length}
                    onPageChange={(page) => setCurrentPage(page)}
                    onRowsPerPageChange={(count) => {
                      setRowsPerPage(count)
                      setCurrentPage(1) // Reset to first page on change
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              {(currentFaxes.length > 0 || paginationOffset > 0) && (
                <div
                  className="faxes-pagination"
                  style={{ justifyContent: "end" }}
                >
                  <PaginationBe
                    lastRecord={lastRecord}
                    setPaginationOffset={setPaginationOffset}
                    paginationOffset={paginationOffset}
                    // rowsPerPage={currentFaxes.length}
                    rowsPerPage={fetchedCount}
                  />
                </div>
              )}
            </>
          )}

          {faxToCopy && (
            <PopupCopy
              selectedPractice={selectedPractice}
              faxToCopy={faxToCopy}
              onSave={handleCopySubmit}
              onClose={() => {
                setFaxToCopy(null)
              }}
              actionLoading={actionLoading}
              tab={tab}
              copiedFaxType={copiedFaxType}
            />
          )}

          {faxToUndo && (
            <UndoConfirmationPopup
              onConfirm={handleUndoSubmit}
              faxToUndo={faxToUndo}
              onCancel={() => setFaxToUndo(null)}
              actionLoading={actionLoading}
            />
          )}

          {(addCommentPopup || editCommentPopup) && (
            <CommentPopup
              addCommentPopup={addCommentPopup}
              editCommentPopup={editCommentPopup}
              onSave={(data) => handleCommentAddEdit(data)}
              onClose={() => {
                setAddCommentPopup(null)
                setEditCommentPopup(null)
              }}
              actionLoading={actionLoading}
            />
          )}
          {deleteCommentPopup && (
            <DeleteCommentConfirmationPopup
              onConfirm={() => handleDeleteComment(deleteCommentPopup)}
              onCancel={() => setDeleteCommentPopup(null)}
              actionLoading={actionLoading}
              deleteCommentPopup={deleteCommentPopup}
            />
          )}

          {showDeletePopup && (
            <DeleteConfirmationPopup
              fax={showDeletePopup}
              onConfirm={() => handleDeleteFax()}
              onCancel={() => setShowDeletePopup(null)}
              actionLoading={actionLoading}
            />
          )}

          {showCancelPopup && (
            <CancelConfirmationPopup
              showCancelPopup={showCancelPopup}
              onConfirm={() => handleCancelFax(showCancelPopup)}
              onCancel={() => setShowCancelPopup(null)}
              actionLoading={actionLoading}
            />
          )}

          {showPhonebookPopup && (
            <PhonebookModal
              onSave={handleAddOrEditPhonebook}
              actionLoading={actionLoading}
              onClose={() => {
                setShowPhonebookPopup(null)
              }}
              practices={practices}
              fromInOutBound={{
                faxNumber: showPhonebookPopup,
                type:
                  selectedPractice?.type === "practice"
                    ? "PRACTICE"
                    : "PERSONAL",
              }}
            />
          )}

          {showFUPopup && (
            <SendUserForm
              onSave={handleSendToUser}
              actionLoading={actionLoading}
              onClose={() => {
                setShowFUPopup(null)
              }}
              selectedPractice={selectedPractice}
              selectedFax={{
                appId: selectedPractice?.appId,
                ...showFUPopup,
              }}
              document={document}
            />
          )}

          {showFFPopup && (
            <SendFaxForm
              onSave={handleSendFax}
              actionLoading={actionLoading}
              onClose={() => {
                setShowFFPopup(null)
              }}
              selectedPractice={selectedPractice}
              selectedFax={{
                appId: selectedPractice?.appId,
                ...showFFPopup,
              }}
            />
          )}
        </div>
      )}
    </>
  )
}

export default BoundInOut

const PopupCopy = ({
  selectedPractice,
  faxToCopy,
  onClose,
  onSave,
  actionLoading,
  tab,
  copiedFaxType,
}) => {
  const [selectedFolder, setSelectedFolder] = useState(
    selectedPractice?.subFolderWithCopiedFaxes[0]?.subFolderName,
  )

  const handleSubmit = (e) => {
    e.preventDefault()

    let outboundComments = {}
    if (tab === "outbound" || copiedFaxType === "OUTBOUND_FAX") {
      outboundComments = {
        outboundComment1:
          faxToCopy?.client_tracking_data?.client_matter ||
          faxToCopy?.outboundComment1,
        outboundComment2:
          faxToCopy?.client_tracking_data?.client_name ||
          faxToCopy?.outboundComment2,
      }
    }

    onSave({
      practiceId: selectedPractice.practiceId,
      subFolder: selectedFolder,
      userId: faxToCopy.userId,
      faxId: faxToCopy.fax_id,
      completedTimestamp: moment
        .utc(faxToCopy.completed_timestamp)
        .tz("America/New_York")
        .format("MM/DD/YYYY hh:mm A"),
      pages: faxToCopy.pages,
      faxStatus: faxToCopy.fax_status,
      appId: selectedPractice.appId,
      faxNumber:
        tab === "outbound"
          ? getFaxNumberToDisplayOutbound(faxToCopy)
          : getFaxNumberToDisplayInbound(faxToCopy),
      faxType: tab === "outbound" ? "OUTBOUND_FAX" : "INBOUND_FAX",
      ...outboundComments,
    })
  }

  const subFolders = selectedPractice?.subFolderWithCopiedFaxes.filter(
    (f) => f.subFolderName !== "Trash",
  )

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">Move Fax</h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
        <form className="popup-group" onSubmit={handleSubmit}>
          {actionLoading ? (
            <div>Moving ...</div>
          ) : (
            <>
              {subFolders.length > 0 ? (
                <>
                  <div className="form-group">
                    <label htmlFor="appId">
                      Move To: <span className="mandatory">*</span>
                    </label>
                    <select
                      id="appId"
                      className="select-dropdown"
                      onChange={(e) => {
                        setSelectedFolder(e.target.value)
                      }}
                      value={selectedFolder || ""}
                    >
                      {subFolders?.map((s, i) => (
                        <option key={i} value={s.subFolderName}>
                          {s.subFolderName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="popup-buttons" style={{ marginTop: "50px" }}>
                    <button
                      className="popup-button cancel"
                      type="button"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button className="popup-button save" type="submit">
                      Save
                    </button>
                  </div>
                </>
              ) : (
                <div className="form-group">
                  No subfolder available for assign.
                </div>
              )}
            </>
          )}
        </form>
      </div>
    </div>
  )
}

const UndoConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  faxToUndo,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "20px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to undo the fax?`}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button
                className="save"
                onClick={() =>
                  onConfirm({
                    copiedId: faxToUndo.copiedId,
                    faxId: faxToUndo.faxId,
                  })
                }
              >
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const CommentPopup = ({
  onClose,
  onSave,
  addCommentPopup,
  editCommentPopup,
  actionLoading,
}) => {
  const [comment, setComment] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const commentKey = editCommentPopup?.commentKey || addCommentPopup?.commentKey

  useEffect(() => {
    if (editCommentPopup) {
      // pick the right comment field dynamically
      const commentValue = editCommentPopup?.[editCommentPopup.commentEditKey]
      setComment(commentValue || "")
    }
  }, [editCommentPopup])

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!comment.trim()) {
      setErrorMessage("Comment is required.")
      return
    }

    // prepare variables first
    const faxId = editCommentPopup
      ? editCommentPopup?.fax_id
      : addCommentPopup?.fax_id

    const action = editCommentPopup?.fax_id ? "edit" : "add"

    // we passed commentKey earlier when opening the popup

    // now build params
    const params = {
      faxId,
      comment,
      action,
      commentKey,
      userId: editCommentPopup
        ? editCommentPopup?.userId
        : addCommentPopup?.userId,
    }

    onSave(params)
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">
            {editCommentPopup ? `Update` : `Add`} {commentKey}
          </h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        <form className="popup-group" onSubmit={handleSubmit}>
          <div className="form-group">
            {/* <label htmlFor="comment">
              Comment: <span className="mandatory">*</span>
            </label> */}
            <input
              type="text"
              id="comment"
              value={comment}
              onChange={(e) => {
                setComment(e.target.value)
                setErrorMessage("")
              }}
              maxLength={45}
            />
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="popup-buttons" style={{ marginTop: "5px" }}>
            <button
              className="popup-button cancel"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="popup-button save" type="submit">
              {actionLoading ? `Saving ...` : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const DeleteCommentConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  deleteCommentPopup,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "10px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to delete the ${deleteCommentPopup.commentKey}?`}
            </p>
            <p style={{ fontWeight: "bold" }}>
              {deleteCommentPopup?.[deleteCommentPopup.commentKey]}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const DeleteConfirmationPopup = ({
  fax,
  onConfirm,
  onCancel,
  actionLoading,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "20px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {fax?.permanentDelete
                ? `Are you sure you want to delete this fax?`
                : `Are you sure you want to move this fax to trash folder?`}
            </p>

            {fax?.permanentDelete && (
              <p
                style={{
                  display: "flex",
                }}
              >
                <AlertTriangle size={20} color="orange" />
                This will permanently remove the fax. Once deleted, it cannot be
                recovered.
              </p>
            )}

            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const SendUserForm = ({
  onClose,
  onSave,
  actionLoading,
  selectedPractice,
  selectedFax,
}) => {
  const [email, setEmail] = useState("")
  const [emailSubject, setEmailSubject] = useState("")
  const [emailMessage, setEmailMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!email) {
      setErrorMessage("Email is required.")
      return
    } else {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setErrorMessage("Email is incorrect.")
        return
      }
    }

    if (!emailSubject) {
      setErrorMessage("Subject is required.")
      return
    }

    if (!emailMessage) {
      setErrorMessage("Message is required.")
      return
    }

    const formData = {
      recipientEmail: email.trim(),
      subject: emailSubject,
      bodyText: emailMessage,
      userId: selectedFax?.userId,
      faxId: selectedFax?.fax_id,
      appId: selectedFax?.appId,
      faxNumber: selectedFax?.faxNumber,
      faxNumberToDisplay: selectedFax?.faxNumberToDisplay,
    }

    onSave(formData)
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        {actionLoading ? (
          <div className="loading" style={{ padding: "20px" }}>
            In Progress ...
          </div>
        ) : (
          <>
            <div className="checkbox-popup-header">
              <h3 className="popup-title">Forward via Email</h3>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
            <form
              className="popup-group form-container"
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label htmlFor="email">
                  Email: <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="emailSubject">
                  Subject: <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  id="emailSubject"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="emailMessage">
                  Message: <span className="mandatory">*</span>
                </label>
                <textarea
                  id="emailMessage"
                  value={emailMessage}
                  onChange={(e) => setEmailMessage(e.target.value)}
                  style={{
                    width: "100%",
                    minHeight: "80px",
                    resize: "vertical",
                  }}
                ></textarea>
              </div>

              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              <div className="popup-buttons">
                <button
                  type="button"
                  className="popup-button cancel"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="popup-button save">
                  Send
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

const SendFaxForm = ({
  onClose,
  onSave,
  actionLoading,
  selectedPractice,
  selectedFax,
  //document,
}) => {
  const [toName, setToName] = useState("")
  const [toCompany, setToCompany] = useState("")
  const [faxNumber, setFaxNumber] = useState("")
  const [comment1, setComment1] = useState("")
  const [comment2, setComment2] = useState("")
  const [includeCoverPage, setIncludeCoverPage] = useState(false)
  const [fromName, setFromName] = useState("")
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [destinationFaxNumberLoading, setDestinationFaxNumberLoading] =
    useState(false)
  const [destinationfaxNumbers, setDestinationfaxNumbers] = useState([])

  const fetchDestinationFaxNumbers = async () => {
    setDestinationFaxNumberLoading(true)

    // let type = "PERSONAL"
    // let qString = ""
    // if (showComposePopup?.section === "queue" && selectedQueueOrNetId) {
    //   type = "QUEUE"
    //   qString = `?queue=${selectedQueueOrNetId}`
    // }

    try {
      const faxNumbers = await get(
        `/phonebook/phonebooksByPractice?practiceName=${selectedPractice?.practiceName}`,
      )

      setDestinationfaxNumbers(faxNumbers)
      setDestinationFaxNumberLoading(false)
    } catch (error) {
      console.error("Failed to fetch fetchFaxNumbers", error)
      setDestinationFaxNumberLoading(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!faxNumber) {
      setErrorMessage("Fax Number is required.")
      return
    } else {
      const errorMsg = validateFaxNumberOnlyDigit(faxNumber?.trim())

      if (errorMsg) {
        setErrorMessage(errorMsg)
        return
      }
    }

    // if (includeCoverPage && (!fromName || !subject || !message)) {
    //   setErrorMessage("All cover page fields must be filled if included.")
    //   return
    // }

    const formData = {
      destinations: [
        {
          to_name: toName,
          to_company: toCompany,
          fax_number: prepareFinalFaxNumber(faxNumber),
        },
      ],
      include_cover_page: includeCoverPage,
      coverPageOptions: includeCoverPage
        ? {
            from_name: includeCoverPage ? fromName : null,
            subject: includeCoverPage ? subject : null,
            message: includeCoverPage ? message : null,
          }
        : {},
      userId: selectedFax?.userId,
      faxId: selectedFax?.fax_id,
      appId: selectedFax?.appId,
      faxNumber: selectedFax?.faxNumber,
      faxNumberToDisplay: selectedFax?.faxNumberToDisplay,
      comment1,
      comment2,
    }

    onSave(formData)
  }

  const optionDestinationFaxNumbers = destinationfaxNumbers.map((fax) => ({
    toName: `${fax.firstName} ${fax.lastName}`,
    toCompany: `${fax.company}`,
    value: fax.faxNumber,
    label: `${formatFaxNumber(fax.faxNumber)} | ${fax.firstName} ${
      fax.lastName
    } ${fax?.company ? `| ${fax?.company}` : ""}`,
  }))

  useEffect(() => {
    if (selectedPractice) {
      fetchDestinationFaxNumbers()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice])

  return (
    <div className="popup-overlay">
      <div className="popup send-fax-popup">
        {actionLoading ? (
          <div className="loading" style={{ padding: "20px" }}>
            In Progress ...
          </div>
        ) : (
          <>
            <div className="checkbox-popup-header">
              <h3 className="popup-title">Forward to Fax</h3>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
            <form
              className="popup-group form-container send-fax-form"
              onSubmit={handleSubmit}
            >
              <div className="send-fax-scroll-body">
                <div className="form-group">
                  <label htmlFor="faxNumber">
                    Fax Number: <span className="mandatory">*</span>
                    <FaxNumberToolTip />
                  </label>
                  {/* <input
                    type="text"
                    id="faxNumber"
                    value={faxNumber}
                    onChange={(e) => setFaxNumber(e.target.value)}
                  /> */}

                  {destinationFaxNumberLoading ? (
                    <div style={{ textAlign: "left", padding: "10px" }}>
                      Loading...
                    </div>
                  ) : (
                    <FaxSearchInput
                      faxNumber={faxNumber}
                      setFaxNumber={setFaxNumber}
                      setToName={setToName}
                      setToCompany={setToCompany}
                      optionDestinationFaxNumbers={optionDestinationFaxNumbers}
                    />
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="toName">To Name:</label>
                  <input
                    type="text"
                    id="toName"
                    value={toName}
                    onChange={(e) => setToName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="toCompany">To Company:</label>
                  <input
                    type="text"
                    id="toCompany"
                    value={toCompany}
                    onChange={(e) => setToCompany(e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="comment1">Comment1:</label>
                  <input
                    type="text"
                    id="comment1"
                    value={comment1}
                    onChange={(e) => setComment1(e.target.value)}
                    maxLength={45}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="comment2">Comment2:</label>
                  <input
                    type="text"
                    id="comment2"
                    value={comment2}
                    onChange={(e) => setComment2(e.target.value)}
                    maxLength={45}
                  />
                </div>

                <div
                  className="form-group checkbox-group"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <div>
                    <input
                      type="checkbox"
                      id="includeCoverPage"
                      checked={includeCoverPage}
                      onChange={(e) => setIncludeCoverPage(e.target.checked)}
                      style={{ marginRight: "5px", width: "20px" }}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="includeCoverPage"
                      style={{
                        whiteSpace: "nowrap",
                        marginBottom: "0px",
                        cursor: "pointer",
                      }}
                    >
                      Include Cover Page
                    </label>
                  </div>
                </div>

                {includeCoverPage && (
                  <>
                    <div className="form-group">
                      <label htmlFor="fromName">From Name:</label>
                      <input
                        type="text"
                        id="fromName"
                        value={fromName}
                        onChange={(e) => setFromName(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="subject">Subject:</label>
                      <input
                        type="text"
                        id="subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">Message:</label>
                      <textarea
                        id="message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        style={{
                          width: "100%",
                          minHeight: "80px",
                          resize: "vertical",
                        }}
                      ></textarea>
                    </div>
                  </>
                )}
              </div>

              <div className="send-fax-footer">
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}

                <div className="popup-buttons">
                  <button
                    type="button"
                    className="popup-button cancel"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="popup-button save">
                    Send
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

function FaxSearchInput({
  faxNumber,
  setFaxNumber,
  setToName,
  setToCompany,
  optionDestinationFaxNumbers,
}) {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState("")
  const [hoverIndex, setHoverIndex] = useState(null)

  // keep local query in sync with external faxNumber
  useEffect(() => {
    const v = typeof faxNumber === "string" ? faxNumber : faxNumber?.value || ""
    setQuery(v || "")
  }, [faxNumber])

  const filteredOptions = useMemo(() => {
    if (!query) return optionDestinationFaxNumbers || []
    const q = query.toLowerCase().trim().replace(/-/g, "")
    return (optionDestinationFaxNumbers || []).filter((opt) =>
      String(
        opt.label.trim().replace(/-/g, "") ||
          opt.value.trim().replace(/-/g, "") ||
          "",
      )
        .toLowerCase()
        .includes(q),
    )
  }, [query, optionDestinationFaxNumbers])

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        id="faxNumber"
        name="faxNumber"
        type="text"
        placeholder="Enter a fax number"
        value={query}
        onChange={(e) => {
          const v = e.target.value
          setQuery(v)

          // keep same shape as react-select: { value, label }
          setFaxNumber(v || null)

          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => {
          // allow click to register before closing
          setTimeout(() => setOpen(false), 150)
        }}
        autoComplete="off" // disable browser suggestions
        autoCorrect="off"
        spellCheck={false}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: 0,
        }}
      />

      {open && filteredOptions.length > 0 && (
        <ul className="fax-search-input-ul">
          {filteredOptions.map((opt, idx) => (
            <li
              key={opt.value}
              onMouseDown={(e) => {
                e.preventDefault() // prevent blur before click
                setQuery(formatFaxNumber(opt.value))

                setFaxNumber(formatFaxNumber(opt.value))
                // setToName(opt.toName)
                // setToCompany(opt.toCompany)

                setToName(isEmpty(opt.toName, true) ? "" : opt.toName)
                setToCompany(isEmpty(opt.toCompany, true) ? "" : opt.toCompany)

                setOpen(false)
              }}
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
              style={{
                padding: "7px 10px",
                marginTop: idx === 0 ? "5px" : "0px",
                cursor: "pointer",
                backgroundColor:
                  hoverIndex === idx ? "#bedaf8ff" : "transparent", // 👈 hover effect
              }}
            >
              {opt.label || opt.value}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

const CancelConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  showCancelPopup,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "15px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to cancel the fax?`}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
